import globalWin from '@/utils/globalWin.ts';
import delegate from 'delegate';
import { htmlDecimalDecode, decodeUnicodeToString } from '@/utils/htmlDecode';
import { addUrlInfo } from '@/utils/urlTools';

/**
 * action = message，消息相关
 * qdweb://webim/message/***
 */
const actionMessage = {
  key: 'message',

  /**
   * 发送c2b消息
   */
  sendc2b(params) {
    globalWin.sendTextMessage(params.content);
  },

  /**
   * 发送不可见（不上屏幕）的消息
   */
  extsendc2b(params) {
    globalWin.sendQDMenuMessage({
      args: params.href,
      text: params.content,
    });

    // 点击后 滚动到消息列表底部。
    globalWin.scrollToBottom();
  },

  /**
   * 留言表单
   */
  leaveform(params) {
    globalWin.createLeaveMessage({ type: 102, formParams: params }, { dir: 'b2c' });

    console.log('[leaveform]', params);
    // 私有化版本中，留言采用链接弹出新页面的方式进行处理。
    // 因此这里可能不需要处理了。
    // 也可能要处理一下参数，打开新窗口
    // window.open( params );
  },

  /**
   * 发送文本消息，并且附加额外内容
   * 对应协议： qdim://webim/message/ext2robotsendc2b?content=内容啊内容&ext={xyz}
   * https://doc.weixin.qq.com/flowchart/f3_APMA7wbNACcCKRH1PVST2qS0uj0VW?scode=AJEAIQdfAAoJuKl8CCAPMA7wbNACc
   * @param {*} params
   * @param {*} options
   */
  ext2robotsendc2b(oldParams) {
    const href = htmlDecimalDecode(oldParams.href);
    const { params } = parseQdwebURL(href);
    params.content = decodeUnicodeToString(params.content);
    params && globalWin.sendTextMessage(params.content, {
      robot_ctrl: {
        str_ext2robot: params.ext || '',
      },
    });
  },
  /**
   * 排队中C侧点击切换客服，新增
   */
  newQueueHandle(params) {
    console.log('[newQueueHandle]', params);
    // 私有化版本中，不需要处理此逻辑
  },

  /**
   * 刷新页面
   */
  reload() {
    location.reload();
  },

  /**
   * C侧接入后切换客服。。。 很古老的逻辑。
   */
  changeNewKF(params) {
    // 私有化版本中，不需要处理此逻辑
    console.log('[changeNewKF]', params);
  },
};

/**
 * action = launch 小程序启动相关
 * qdweb://webim/launch/***
 */
const actionLaunch = {
  key: 'launch',

  /**
   * H5嵌入小程序webview时调用小程序api
   */
  miniprogram(arg) {
    if (!wx || !wx.miniProgram) {
      console.log('[launch/miniprogram]在非微信内置webview环境中无法运行');
      return;
    }

    const params = { ...arg };
    if (params.url) {
      params.url = decodeURIComponent(params.url);
    }
    console.log('[miniprogram]', params, arg);
    wx.miniProgram[params.interface] && wx.miniProgram[params.interface](params);
  },

  /**
   * 新增，小程序处理逻辑
   * qdweb://webim/launch/wxapp?interface=navigateToMiniProgram&appId=xxxx
   * @param {JSON} arg
   */
  wxapp(arg) {
    const params = { ...arg };
    if (params.path) {
      params.path = decodeURIComponent(params.path);
    }

    if (!wx || !wx[params.interface]) {
      console.log('[launch/wxapp]请确认调用的API及参数是否正确');
      return;
    }

    console.log('[wxapp]', params, arg);

    wx[params.interface](params);
  },
  pageaction(arg = {}) {
    const params = { ...arg };
    const { actionType = '' } = params;
    switch (actionType) {
      // 打开表单填写弹窗
      case 'consultForm':
        globalWin.switchConsultForm(true, params);
        break;
      default:
        break;
    }
  },
  /**
   * iframe中postMessage
   * @param {*} params
   */
  postMessage(params = {}) {
    if (window && window.parent && window.parent.postMessage) {
      window.parent.postMessage(params, '*');
    }
  },
};


const PROTOCOL_PREFIX = /((qdweb)|(qdim)|(mqqwpa)):\/\//;
const PROTOCOL_MAP = {};
const PROTOCOL_MQQ = 'mqqwpa://'; // 私有化特殊协议

PROTOCOL_MAP[actionMessage.key] = actionMessage;
PROTOCOL_MAP[actionLaunch.key] = actionLaunch;

/**
 * 解析 qdweb://, qdim:// 或 mqqwpa:// 链接
 * @param {String}} href
 *x
 */
export function parseQdwebURL(href) {
  if (PROTOCOL_PREFIX.test(href)) {
    const str = href.replace(PROTOCOL_PREFIX, '');
    let keyArr = [];
    let paramArr = [];
    const paramObj = {};

    const strArr = str.split('?');
    keyArr = strArr[0].split('/');
    if (strArr.length > 1) {
      paramArr = strArr[1].split('&');
      paramArr.forEach((param) => {
        const p = param.split('=');
        if (p.length > 1) {
          const [key, val] = p;
          paramObj[key] = val;
        } else {
          paramObj[p[0]] = true;
        }
      });
    }

    if (keyArr.length > 0) {
      const [namespace, action, method] = keyArr;
      return { namespace, action, method, params: paramObj, href };
    }
  }

  return false;
}


// 消息中的连接点击
/**
 * 点击单个url
 * @param {String}} url 连接
 */
export function handleLinkClick(url, target, options) {
  console.log('[handleLinkClick]', url, target, options);

  const qdAPI = parseQdwebURL(url);

  if (qdAPI !== false) {
    const { action, method, params, href } = qdAPI;

    if (href.indexOf(PROTOCOL_MQQ) === 0 || method === 'extsendc2b') {
      // 如果是 mqqwpa:// 这种协议，直接调用命令
      // 另外，私有化webim这里extsendc2b命令直接上行整个url。
      PROTOCOL_MAP.message.extsendc2b({
        href,
        content: params.content || '',
      });
      return;
    }

    if (method === 'ext2robotsendc2b') {
      // 如果是 mqqwpa:// 这种协议，直接调用命令
      // 另外，私有化webim这里extsendc2b命令直接上行整个url。
      PROTOCOL_MAP.message.ext2robotsendc2b({
        href,
        content: params.content || '',
      });
      return;
    }

    const mAction = PROTOCOL_MAP[action];
    if (mAction && mAction[method] && typeof (mAction[method]) === 'function') {
      mAction[method](params, options);
    }
  } else {
    if (typeof url !== 'string') {
      return;
    }
    // 前缀带空格跳转会报错
    const jumpUrl = url.trim();
    // 如果url不是http开头，则直接返回
    if (!/^(http|tel|mailto)/.test(jumpUrl)) {
      return;
    }
    // url开头需要判断是否需要绑定用户信息
    if (/^(http)/.test(jumpUrl)) {
      window.open(addUrlInfo(jumpUrl));
      return;
    }
    window.open(jumpUrl);
  }
}

/**
 * 绑定区域内的所有链接点击事件
 * @param {String} url
 * @param {JSON} conf = { callback: 点击后的回调函数, options: 额外信息 };
 */
export default function bindlLinkClick(box, doms, conf = {}) {
  const { callback, options } = conf;
  delegate(box, doms, 'click', (e) => {
    e.preventDefault();
    const link = e.delegateTarget;

    typeof(callback) === 'function' && callback(link);

    handleLinkClick(link.getAttribute('href'), link.getAttribute('target'), options);
    return false;
  });
}
